// import React from 'react';

// const amenitiesData = [
//   {
//     iconClass: 'flaticon-wifi-signal',
//     title: 'High Speed Wifi',
//     description: 'With our service you may enjoy the finest life in our resort.'
//   },
//   {
//     iconClass: 'flaticon-car',
//     title: 'Pick & Drop Facility',
//     description: 'With our service you may enjoy the finest life in our resort.'
//   },
//   {
//     iconClass: 'flaticon-smart-tv',
//     title: 'Smart TV',
//     description: 'With our service you may enjoy the finest life in our resort.'
//   },
//   {
//     iconClass: 'flaticon-pool',
//     title: 'Swimming Pool',
//     description: 'With our service you may enjoy the finest life in our resort.'
//   },
//   {
//     iconClass: 'flaticon-breakfast',
//     title: 'Breakfast Included',
//     description: 'With our service you may enjoy the finest life in our resort.'
//   },
//   {
//     iconClass: 'flaticon-bath',
//     title: 'Shower Bathtub',
//     description: 'With our service you may enjoy the finest life in our resort.'
//   }
// ];

// const Amenities = () => {
//   return (
//     <section className="amenities-section light-bg mx-60 border-shape-bottom">
//       <div className="auto-container">
//         <div className="title-box text-center">
//           <div className="sub-title">amenities</div>
//           <h2 className="sec-title">Make Your Stay Memorable</h2>
//         </div>

//         <div className="row">
//           {amenitiesData.map((item, index) => (
//             <div key={index} className="col-lg-4 amenities-block">
//               <div className="inner-box">
//                 <div className="icon">
//                   <i className={item.iconClass}></i>
//                 </div>
//                 <h1>{item.title}</h1>
//                 <div className="text">{item.description}</div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Amenities;
















// import React from "react";

// const amenitiesData = [
//   {
//     iconClass: "flaticon-wifi-signal",
//     title: "High-Speed WiFi",
//     description:
//       "Stay connected even in the heart of the jungle with seamless high-speed internet access."
//   },
//   {
//     iconClass: "flaticon-car",
//     title: "Pick & Drop Facility",
//     description:
//       "Comfortable pickup and drop service from nearby stations or airports for a hassle-free journey."
//   },
//   {
//     iconClass: "flaticon-smart-tv",
//     title: "Smart TV & Entertainment",
//     description:
//       "Relax indoors with access to your favorite shows and streaming platforms after a day of adventure."
//   },
//   {
//     iconClass: "flaticon-pool",
//     title: "Nature View Swimming Pool",
//     description:
//       "Unwind in our crystal-clear pool surrounded by forest views and the soothing sounds of nature."
//   },
//   {
//     iconClass: "flaticon-breakfast",
//     title: "Delicious Meals Included",
//     description:
//       "Enjoy freshly prepared Veg & Non-Veg meals made from local ingredients and authentic flavors."
//   },
//    {
//     iconClass: "flaticon-pool",
//     title: "Hot Water Facility",
//     description:
//       "Enjoy 24/7 hot water availability for a comfortable and relaxing stay, even during cool jungle mornings."
//   },

//   {
//     iconClass: "flaticon-campfire",
//     title: "Bonfire & Jungle Activities",
//     description:
//       "Experience cozy bonfire nights, guided jungle safaris, and outdoor fun that bring you closer to the wild."
//   },

 
//   {
//     iconClass: "flaticon-campfire",
//     title: "24×7 Electricity Backup",
//     description:
//       "Uninterrupted power supply with full backup ensures comfort and convenience throughout your stay."
//   }
// ];

// const Amenities = () => {
//   return (
//     <section className="amenities-section light-bg mx-60 border-shape-bottom">
//       <div className="auto-container">
//         <div className="title-box text-center">
//           <div className="sub-title">amenities</div>
//           <h2 className="sec-title">Make Your Woodland Escape Memorable</h2>
//         </div>

//         <div className="row">
//           {amenitiesData.map((item, index) => (
//             <div key={index} className="col-lg-4 col-md-6 amenities-block">
//               <div className="inner-box">
//                 <div className="icon">
//                   <i className={item.iconClass}></i>
//                 </div>
//                 <h3>{item.title}</h3>
//                 <div className="text">{item.description}</div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Amenities;











import React from "react";
import { FaWind } from "react-icons/fa";

/* INLINE SVG ICONS (MATCHING STYLE) */
const HotWaterIcon = () => (
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#0a2540" strokeWidth="1.6">
    <path d="M4 14s1-2 4-2 4 2 4 2 1-2 4-2 4 2 4 2" />
    <path d="M6 6c0 2 2 2 2 4" />
    <path d="M12 6c0 2 2 2 2 4" />
    <path d="M18 6c0 2 2 2 2 4" />
  </svg>
);
const CampfireIcon = () => (
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#0a2540" strokeWidth="1.6">
    <path d="M12 2c1.5 3-1 4.5-1 7a3 3 0 006 0c0-2.5-3-4-5-7z" />
    <path d="M5 21h14" />
    <path d="M7 18h10" />
  </svg>
);


const PowerIcon = () => (
  <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#0a2540" strokeWidth="1.6">
    <path d="M13 2L3 14h7l-1 8 10-12h-7l1-8z" />
  </svg>
);

const amenitiesData = [
  {
    icon: <i className="flaticon-wifi-signal"></i>,
    title: "High-Speed WiFi",
    description:
      "Stay connected even in the heart of the jungle with seamless high-speed internet access."
  },
  {
    icon: <i className="flaticon-car"></i>,
    title: "Pick & Drop Facility",
    description:
      "Comfortable pickup and drop service from nearby stations or airports for a hassle-free journey."
  },
  {
    icon: <i className="flaticon-smart-tv"></i>,
    title: "Smart TV & Entertainment",
    description:
      "Relax indoors with access to your favorite shows and streaming platforms after a day of adventure."
  },
  {
    icon: <i className="flaticon-pool"></i>,
    title: "Nature View Swimming Pool",
    description:
      "Unwind in our crystal-clear pool surrounded by forest views and the soothing sounds of nature."
  },
  {
    icon: <i className="flaticon-breakfast"></i>,
    title: "Delicious Meals Included",
    description:
      "Enjoy freshly prepared Veg & Non-Veg meals made from local ingredients and authentic flavors."
  },
  {
    icon: <HotWaterIcon />,
    title: "Hot Water Facility",
    description:
      "Enjoy 24/7 hot water availability for a comfortable and relaxing stay, even during cool jungle mornings."
  },
{
  icon: <CampfireIcon />,
  title: "Bonfire & Jungle Activities",
  description:
    "Experience cozy bonfire nights, guided jungle safaris, and outdoor fun that bring you closer to the wild."
},


  {
    icon: <PowerIcon />,
    title: "24×7 Electricity Backup",
    description:
      "Uninterrupted power supply with full backup ensures comfort and convenience throughout your stay."
  },
{
  icon: <FaWind />,
  title: "Fresh Air & Natural Surroundings",
  description:
    "Breathe in pure, refreshing air surrounded by lush greenery and a peaceful jungle atmosphere."
}


];

const Amenities = () => {
  return (
    <section className="amenities-section light-bg mx-60 border-shape-bottom">
      <div className="auto-container">
        <div className="title-box text-center">
          <div className="sub-title">amenities</div>
          <h2 className="sec-title">Make Your Woodland Escape Memorable</h2>
        </div>

        <div className="row">
          {amenitiesData.map((item, index) => (
            <div key={index} className="col-lg-4 col-md-6 amenities-block">
              <div className="inner-box">
                <div className="icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <div className="text">{item.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Amenities;
